// extracted by mini-css-extract-plugin
export var container = "_3k-1";
export var editor = "_3k-2";
export var resizable = "_3k-3";
export var wrapper = "_3k-0";